import React from 'react'

const DetailComment = () => {
return (
    <div>DetailComment</div>
  )
}

export default DetailComment